/* eslint-disable jsx-a11y/alt-text */
import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from "../styles.module.scss";
import { cpfValidation } from "../../../../../../../../utils/CpfValidation";
import { cnpjValidation } from "../../../../../../../../utils/CnpjValidation";
import { LuPackageCheck } from "react-icons/lu";
import Title from "./Title";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";

export const Delivery = ({
  handleBackButton,
  handleSubmit,
  setReceiverData,
  setEvidenceImage,
  evidenceImage,
  evidenceError,
  setEvidenceError,
  needEvidence
}) => {
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState();
  const [cpf, setCpf] = useState("");
  const [cpfError, setCpfError] = useState();
  const [imgPreview, setImgPreview] = useState()

  const fileInputRef = useRef(null)

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setEvidenceImage(file);
    }
  };

  const handleValidationName = useCallback(value => {
    if (value.length === 0) {
      setNameError("Campo obrigatório");
    } else if (value.length === 1) {
      setNameError("Nome deve ter pelo menos 2 caracteres");
    } else {
      setNameError();
    }
  }, []);

  const handleValidationCNPJ = value => {
    const validCnpj = cnpjValidation({
      cnpj: value,
      emptyCnpj: "Campo obrigatório",
      incorrectCnpj: "CNPJ incorreto"
    });
    setCpfError(validCnpj.message);
  };

  const handleValidationCPF = value => {
    const validCPF = cpfValidation({
      cpf: value,
      emptyCpf: "Campo obrigatório",
      incorrectCpf: "CPF incorreto"
    });
    setCpfError(validCPF.message.length ? validCPF.message : undefined);
  };

  const handleInputName = useCallback(
    e => {
      let value = e.currentTarget.value;
      setName(value);
      handleValidationName(value);
    },
    [handleValidationName]
  );

  const handleInputCpf = useCallback(e => {
    let inputValue = e.currentTarget.value.replace(/\W/gi, "");

    if (inputValue.length <= 11) {
      inputValue = inputValue.replace(/\D/g, "");
      inputValue = inputValue.replace(
        /^(\d{3})(\d{3})(\d{3})(\d{2})/,
        "$1.$2.$3-$4"
      );
      e.currentTarget.inputValue = inputValue;
      handleValidationCPF(inputValue);
      setCpf(inputValue);
    } else {
      e.currentTarget.maxLength = 18;

      inputValue = inputValue.replace(/\D/g, "");
      inputValue = inputValue.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        "$1.$2.$3/$4-$5"
      );
      e.currentTarget.inputValue = inputValue;
      handleValidationCNPJ(inputValue);
      setCpf(inputValue);
    }
  }, []);

  const handleSave = () => {
    if (name && cpf) {
      handleSubmit()
      return
    }

    if (!name) {
      setNameError("Campo obrigatório")
    }
    if (!cpf) {
      setCpfError("Campo obrigatório")
    }
  }

  useEffect(() => {
    setReceiverData({
      name, document: cpf?.replace(/\D/g, "")
    })
  }, [name, cpf])

  useEffect(() => {
    if (evidenceImage && typeof evidenceImage !== "string") {
      setImgPreview(URL.createObjectURL(evidenceImage))
      setEvidenceError(undefined)
    }
  }, [evidenceImage])

  return (
    <>
      <div>
        <Title text={"Marcar coleta como realizada"} icon={<LuPackageCheck color="#409e6a" size={40} />} />

        <div className={styles.formContainer}>
          <div className={styles.formSelect}>
            <span>Nome do Responsável <strong style={{ color: "#eb0014" }}>*</strong></span>
            <div className={styles.input}>
              <input
                type="text"
                name="name"
                placeholder="Digite o nome do responsável pela coleta"
                onChange={e => handleInputName(e)}
                value={name}
                autoComplete="1234"
              />
            </div>
            {nameError?.length && <span className={styles.formErrorMsg}>{nameError}</span>}
          </div>
          <div className={styles.formSelect}>
            <span>Documento do Responsável <strong style={{ color: "#eb0014" }}>*</strong></span>
            <div className={styles.input}>
              <input
                type="text"
                name="cpf"
                placeholder="CPF/CNPJ"
                onChange={e => handleInputCpf(e)}
                value={cpf}
              />
            </div>
            {cpfError?.length && <span className={styles.formErrorMsg}>{cpfError}</span>}
          </div>

          {needEvidence && (<>
            {(imgPreview) ?
              (<div className={styles.imageContainer}>
                <div className={styles.image}>
                  <TransformWrapper>
                    <TransformComponent>
                      <img
                        src={imgPreview}
                        alt="Imagem da coleta realizada"
                      />
                    </TransformComponent>
                  </TransformWrapper>
                </div>
              </div>) : (
                <div className={styles.emptyImage}>
                  <p>Nenhuma imagem carregada</p>
                </div>
              )}

            <div className={styles.imageForm}>
              <div className={styles.inputFileContainer}>
                <div
                  className={`${styles.inputFile}`}
                  onClick={handleButtonClick}
                >
                  <span>
                    Inserir imagem
                  </span>
                </div>
              </div>
              <span className={styles.evidenceErrorMsg}>{evidenceError}</span>
              <input type="file" accept="image/*" ref={fileInputRef} style={{ display: "none" }} onChange={handleImageChange} />
            </div>
          </>)}
        </div>

        <div className={styles.buttonContainer}>
          <button
            type="button"
            onClick={handleBackButton}
            className={styles.buttonBack}
          >
            Voltar
          </button>

          <button disabled={nameError || cpfError || evidenceError} onClick={handleSave}>
            Marcar como coletado
          </button>
        </div>
      </div>
    </>
  );
};
